<div class="enrollment-steps" id="merchant-account-step" data-cy="enrollment-merchant-account-step">
  <app-merchant-account-form></app-merchant-account-form>
</div>
